import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetActivitiesClassStudentsQuery,
  GetActivitiesClassStudentsQueryVariables,
} from './classroom-students.graphql.generated';
import { GET_ACTIVITIES_CLASS_STUDENTS } from './classroom-students.graphql';
import { useCurrentClassVar } from 'approot/classes/classes.hooks';

export const useGetClassStudents = ({
  classId,
  fetchPolicy,
  skip,
  onComplete,
}: {
  classId: number | null;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  onComplete?: (response: GetActivitiesClassStudentsQuery) => void;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetActivitiesClassStudentsQuery,
    GetActivitiesClassStudentsQueryVariables
  >(GET_ACTIVITIES_CLASS_STUDENTS, {
    skip: !classId || skip,
    fetchPolicy,
    variables: {
      input: {
        classId: classId || 0,
      },
    },
    onCompleted: onComplete,
  });

  return {
    data,
    loading,
    error,
  };
};

export const useGetClassStudentsCount = ({
  fetchPolicy = 'cache-first',
  skip,
  onComplete,
}: {
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  onComplete?: (count: number) => void;
}) => {
  const currentClass = useCurrentClassVar();
  const userClassId = currentClass?.id;

  const { data: classStudents } = useGetClassStudents({
    fetchPolicy: fetchPolicy || 'cache-only',
    skip,
    classId: userClassId || null,
    onComplete: res => {
      onComplete?.(res.getClassStudents.length);
    },
  });

  const studentsInClass = classStudents?.getClassStudents || [];
  return studentsInClass.length;
};
